export const landingLink = "https://www.securitec.pe/";

export const bucketUrl = import.meta.env.VITE_BUCKET;

export const templateLink = `${bucketUrl}/templates/strategies/strategy.xlsx`;
